import { Box, Typography } from "@mui/material";
import { customStyles } from "./index.styles";

interface PageHeroProps {
  imageUrl: string;
  title: string;
  altText?: string;
}

const PageHero = ({ imageUrl, title, altText }: PageHeroProps) => {
  return (
    <Box sx={customStyles.coverImageContainer}>
      <Box
        component="img"
        src={imageUrl}
        alt={altText || title}
        sx={customStyles.coverImage}
      />
      <Box sx={customStyles.coverOverlay}>
        <Typography variant="h2" sx={customStyles.coverTitle}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default PageHero;
